import React from 'react';
import {
	Content,
	Label,
	LinearGuageContainer,
	TableCellChart,
	TableCellGroup,
	TableCellGroupDiv,
	TableCellMax,
	TableCellMin,
	TableRow,
	ToggleButton,
} from './CategoryHierarchy.styles';

import { ApIcon } from '@alixpartners/ui-components';
import LinearGauge from '../LinearGuage/LinearGauge';
import { formatSpendWithDecimalAndSymbol } from '../../../utils';

const CategoryHierarchy = props => {
	const {
		data,
		onExpand,
		onToggle,
		showToggleButton,
		isFirstTab,
		isChildOfExpanded = false,
		percentages,
		flippedScale,
		parentName,
	} = props;
	function formatNumber(value, decimalPlaces = 2) {
		return Number.isInteger(value) ? value.toString() : value.toFixed(0);
	}

	const FLIPPED_SCALE = [
		'Average sourcing HC ROI',
		'Actual savings',
		'Indirect spend',
		'Average PO',
		'Wt avg payment term (Days)'
	];

	const AVERAGE_PO_LABEL =
		'Average # of PO’s processed per operational procurement FTE annually';

	const isAveragePO =
		parentName === 'Average PO' || parentName === AVERAGE_PO_LABEL;

	const formatAveragePOValue = value =>
		value || value === 0 ? Number(value).toLocaleString() : '';

	return (
		<>
			{data.map(items => {
				const {
					name,
					level,
					qmin: min,
					qmax: max,
					qmedian: median,
					clientTotalMarker: clientSpend,
					children,
					isExpanded,
					group,
					id,
					clientDirectMarker: clientSpendDirect,
					clientIndirectMarker: clientSpendIndirect,
					showFormattedSpend,
					hideGradient,
					hideChart,
					unit = '',
				} = items;
				const hasChildren = Array.isArray(children) && children.length > 0;
				const icon = isExpanded
					? 'baseline_keyboard_arrow_down'
					: 'baseline_keyboard_arrow_right';
				return (
					<React.Fragment key={id ? id : name}>
						<TableRow
							group={group}
							level={level}
							isFirstTab={isFirstTab}
							isChildOfExpanded={isChildOfExpanded}
						>
							<TableCellGroup>
								<TableCellGroupDiv
									level={level}
									isFirstTab={isFirstTab}
									hasChildren={hasChildren}
								>
									{showToggleButton && (
										<ToggleButton
											onClick={
												hasChildren
													? () => onToggle(level, name, group, isExpanded)
													: () => onExpand(group, level, name, items)
											}
										>
											<ApIcon iconName={icon} iconColor="black" />
										</ToggleButton>
									)}
									<Label>
										{name.endsWith('Term')
											? `${name} (Days)`
											: name == 'Touchless PO'
												? `${name} (%)`
												: name == 'Indirect spend'
													? `Actively managed indirect spend`
													: name == 'Average PO'
														? 'Average # of PO’s processed per operational procurement FTE annually'
														: name}
									</Label>
								</TableCellGroupDiv>
							</TableCellGroup>

							<TableCellMin>
								<Content>
									<Label> </Label>
								</Content>
							</TableCellMin>
							<TableCellMin>
								<Content>
									<Label>
										{isAveragePO
											? formatAveragePOValue(min)
											: !hideChart && showFormattedSpend
												? formatSpendWithDecimalAndSymbol(
														min,
														'$',
														true,
														1,
														'',
														name
												  )?.toUpperCase()
												: (min || min === 0) && `${formatNumber(min)}${unit}`}
										{percentages && '%'}
									</Label>
								</Content>
							</TableCellMin>
							<TableCellChart>
								<LinearGuageContainer>
									{!hideChart && (
										<LinearGauge
											values={{
												group,
												level,
												min,
												max,
												median,
												clientSpend,
												showFormattedSpend,
												clientSpendDirect,
												clientSpendIndirect,
												hideGradient,
												unit,
												name,
												percentages,
												parentName,
											}}
											flippedScale={
												FLIPPED_SCALE.includes(name) || flippedScale
											}
										/>
									)}
								</LinearGuageContainer>
							</TableCellChart>
							<TableCellMax>
								<Content>
									<Label>
										{isAveragePO
											? formatAveragePOValue(max)
											: !hideChart && showFormattedSpend
												? formatSpendWithDecimalAndSymbol(
														max,
														'$',
														true,
														1,
														'',
														name
												  )?.toUpperCase()
												: (max || max === 0) && `${formatNumber(max)}${unit}`}
										{percentages && '%'}
									</Label>
								</Content>
							</TableCellMax>
						</TableRow>
						{isExpanded && (
							<>
								{hasChildren &&
									children.map(child => (
										<CategoryHierarchy
											key={Math.random()}
											data={[child]}
											onExpand={onExpand}
											onToggle={onToggle}
											showToggleButton={showToggleButton}
											isFirstTab={isFirstTab}
											isChildOfExpanded={true}
											percentages={percentages}
											flippedScale={FLIPPED_SCALE.includes(name)}
											parentName={name}
										/>
									))}
							</>
						)}
					</React.Fragment>
				);
			})}
		</>
	);
};

export default CategoryHierarchy;
